import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

const PreviewMap = compose(
  withProps({
    /**
     * Note: create and replace your own key in the Google console.
     * https://console.developers.google.com/apis/dashboard
     * The key "AIzaSyBkNaAGLEVq0YLQMi-PYEMabFeREadYe1Q" can be ONLY used in this sandbox (no forked).
     */
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyCc9Ey-G34a4h9qxNGJERpnKQYi25wy5nA&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: (
      <div style={{ height: `100px`, width: '150px', padding: '5px' }} />
    ),
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    options={{
      disableDefaultUI: true,
    }}
    defaultZoom={16}
    defaultCenter={{ lat: 42.9628803, lng: -87.9202306 }}
  >
    <Marker position={{ lat: 42.9628803, lng: -87.9202306 }} />
  </GoogleMap>
));

ReactDOM.render(<PreviewMap isMarkerShown />, document.getElementById('root'));

export default connect()(PreviewMap);
